export const operationsArabicTranslations: Record<string, string> = {
  'Cancelled session: attendance is locked.': 'المحاضرة ملغية: تعديل الحضور مقفول.',
  'Session end time is unavailable. Attendance is locked.': 'وقت نهاية المحاضرة مش متسجّل. تعديل الحضور مقفول.',
  'Attendance editable until {0} (Cairo).': 'تعديل الحضور متاح لحد {0} بتوقيت مصر.',
  'Attendance is locked: 24 hours have passed since session end.': 'تعديل الحضور اتقفل: عدّى 24 ساعة من نهاية المحاضرة.',
  'Ended by instructor': 'المحاضر أنهى المحاضرة',
  'Scheduled today': 'معادها النهارده',
  'Scheduled start has passed': 'معاد بدايتها عدى',
  'Started by instructor': 'المحاضر بدأ المحاضرة',
  'Sessions on selected date': 'محاضرات اليوم المختار',
  'Session date (Cairo)': 'تاريخ المحاضرة بتوقيت مصر',
  'No sessions on this date.': 'مفيش محاضرات في اليوم ده.',
  'Session {0} of {1}': 'المحاضرة {0} من {1}',
  'Session {0}': 'المحاضرة {0}',
  'Replacement session': 'محاضرة تعويضية',
  'Instructor completion': 'انتهاء المحاضرات عند المحاضر',
  'Attendance recorded': 'تسجيل الحضور',
  '{0} fully recorded · {1} partially recorded': '{0} تسجيل كامل · {1} تسجيل جزئي',
  'Current group roster': 'طلاب الجروب الحاليين',
  'Course sessions': 'محاضرات الكورس',
  '{0} planned · {1} active · {2} cancelled · {3} replacement · {4} rows': '{0} مخططة · {1} فعالة · {2} ملغية · {3} تعويضية · {4} سجل',
  'Historical records across all sessions': 'سجلات الحضور القديمة لكل المحاضرات',
  'Take attendance': 'تسجيل الحضور',
  'Instructor: {0}': 'المحاضر: {0}',
  '{0} students': '{0} طالب',
  'Confirm payments': 'أكد إيصالات الدفع',
  'Review refund requests': 'راجع طلبات الاسترداد',
  'Follow up registrations': 'تابع تسجيلات الطلاب',
  'Schedule waiting students': 'حدد مواعيد للطلاب المستنيين',
  'Review requests': 'راجع الطلبات',
  'Follow up interests': 'تابع المهتمين بالكورسات',
  'Follow up consultations': 'تابع الاستشارات',
  'Follow up overdue tasks': 'تابع المهام المتأخرة',
  'Review submitted tasks': 'راجع المهام اللي اتسلّمت',
  'More follow-ups': 'متابعات تانية',
  'No pending items in the available queues': 'مفيش طلبات مستنية متابعة في القوائم المتاحة',
  'Schedule period': 'فترة الجدول',
  'Tomorrow': 'بكرة',
  'This week': 'الأسبوع ده',
  'Sessions': 'الحصص',
  'No sessions in this period': 'مفيش حصص في الفترة دي',
  'About timetable status': 'عن حالة المعاد',
  'Open tasks': 'مهام مفتوحة',
  'Overdue': 'متأخرة',
  'Awaiting your review': 'مستنية مراجعتك',
  'Current follow-up counts are unavailable': 'أعداد متابعة المهام الحالية مش متاحة',
  'About task counts': 'عن أعداد المهام',
  'Open tasks include overdue work; submitted work awaiting review is counted separately. Expired and cancelled tasks are excluded.': 'المهام المفتوحة بتشمل المتأخرة؛ الشغل اللي اتسلّم ومستني مراجعة ليه عدد لوحده. المهام المنتهية والملغية مش داخلة في الأعداد.',
  'About financial totals': 'عن الأرقام المالية',
  'Net movement is not a safe balance': 'صافي الحركة مش رصيد الخزنة',
  'View all written reports': 'عرض كل تقارير الموظفين المكتوبة',
  'Daily Operations Report': 'تقرير تشغيل اليوم',
  'Report day (Cairo)': 'يوم التقرير بتوقيت مصر',
  'Generated at': 'وقت استخراج التقرير',
  'Generated by': 'استخرج التقرير',
  'Source checked at': 'آخر تحديث للبيانات',
  'Needs attention — current snapshot': 'حالات محتاجة متابعة وقت استخراج التقرير',
  'Finance for report day': 'الحركة المالية في يوم التقرير',
  'Full day schedule': 'جدول اليوم كامل',
  'Time ended does not confirm attendance': 'انتهاء المعاد مش تأكيد لتنفيذ الحصة أو تسجيل الحضور',
  'Timetable status': 'حالة المعاد',
  'Present count': 'عدد الحاضرين',
  'Student count': 'عدد الطلاب',
  'Planned session': 'حصة في الجدول',
  'Time ended': 'انتهى معادها',
  'Time unavailable': 'المعاد مش متاح',
  'Session scheduled': 'في الجدول',
  'Session starts soon': 'هتبدأ قريب',
  'Session time in progress': 'معادها شغال دلوقتي',
  'Financial scope': 'نطاق التقرير المالي',
  'Existing financial report uses UTC date boundaries': 'حدود اليوم المالي حسب التقرير الموجود بتوقيت UTC',
  'Task branch': 'نطاق مهام الفريق',
  'Collected income': 'الإيرادات المحصّلة',
  'Net movement': 'صافي الحركة',
  'Current task status': 'حالة المهام الحالية',
  'Completed — current total': 'مكتملة — إجمالي حالي',
  'Expired — current total': 'منتهية — إجمالي حالي',
  'Employee reports — current scope': 'تقارير الموظفين في النطاق الحالي',
  'Loaded report messages': 'رسائل التقارير المعروضة',
  'Only loaded messages are included; totals cover the full scope': 'التصدير بيشمل الرسائل المعروضة بس؛ الأعداد بتشمل كل التقارير في النطاق',
  'Reception management': 'إدارة الريسبشن',
  'Refresh operations': 'تحديث بيانات التشغيل',
  'Generating report': 'جاري تجهيز التقرير',
  'Loading operations': 'جاري تحميل بيانات التشغيل',
  'Needs attention': 'محتاج متابعة',
  'Current snapshot': 'الحالة الحالية',
  'Finance today': 'مالية النهارده',
  'Movement for report day': 'الحركة في يوم التقرير',
  'Open timetable': 'فتح جدول المواعيد',
  'Open financial report': 'فتح التقرير المالي',
  'Team follow-up': 'متابعة الفريق',
  'Employee reports': 'تقارير الموظفين',
  'Current scope': 'النطاق الحالي',
  'No employees in this task scope': 'مفيش موظفين في نطاق المهام ده',
  'Unknown employee': 'الموظف مش معروف',
  'Selection changed; export again': 'الفرع أو الحساب اتغيّر؛ استخرج التقرير تاني',
  'Could not generate operations report': 'مش قادرين نجهّز تقرير التشغيل',
  'Could not load operations': 'مش قادرين نحمّل بيانات التشغيل',
  'Access not available': 'البيانات دي مش متاحة للصلاحية الحالية',
  'Source unavailable': 'مصدر البيانات مش متاح دلوقتي',
  'Invalid source response': 'بيانات المصدر مش مكتملة أو محتاجة مراجعة',
  'Partial source response': 'المصدر رجّع بيانات ناقصة',
  'Task scope unavailable': 'نطاق مهام الفريق مش متاح',
  'Different task branch': 'مصدر مهام الفريق متاح لفرع تاني؛ اختار فرعك لمتابعتها',
  'Team access required': 'متابعة الفريق محتاجة صلاحية سوبر ريسبشن',
  'Unavailable': 'مش متاح',
  'Currency': 'العملة',
  'Language': 'اللغة',
};
